import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE, heroGuarantees } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-seyes" data-id="element-159" data-mp="9igxnf29y0mt">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-160" data-mp="4n9zemrrxo5a" />

      <div className="relative mx-auto max-w-6xl px-8 pb-16 pt-4 sm:px-14 sm:pb-20 sm:pt-6 lg:pb-28" data-id="element-161" data-mp="127ec173d7daa">
        <div className="mt-4 flex flex-col sm:mt-12 lg:mt-16 lg:grid lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-12" data-id="element-162" data-mp="x8jmznet0shq">
          <div className="contents lg:block" data-id="element-163" data-mp="ncgk2fc4optq">
            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} className="order-1 text-center font-serif text-[2.15rem] leading-tight sm:leading-[1.05] lg:text-left tracking-tight text-slate-900 sm:text-6xl lg:text-[3.75rem]" data-id="element-164" data-mp="nboov5mg0u3z">
              準備好{' '}
              <span className="relative inline-block whitespace-nowrap" data-id="element-165" data-mp="3o5j3nbh1flmc">
                <motion.span aria-hidden="true" initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.3,
                delay: 0.25,
                ease: EASE
              }} className="absolute inset-x-[-0.08em] bottom-[0.08em] top-[0.38em] -z-0 origin-left -rotate-1 rounded-[0.12em] bg-amber-300/80" data-id="element-166" data-mp="399jq3lb5st9t" />
                <span className="relative" data-id="element-167" data-mp="2qleoaje2bidn">一整個學年</span>
              </span>{' '}
              的音樂課，只需{' '}
              <span className="relative inline-block whitespace-nowrap italic text-red-700" data-id="element-168" data-mp="2vj7tpa7jk8cv">
                5 分鐘
                <svg aria-hidden="true" viewBox="0 0 200 14" preserveAspectRatio="none" className="absolute -bottom-1.5 left-0 h-3 w-full sm:-bottom-2.5" data-id="element-169" data-mp="2hl9r122l20d7">
                  <motion.path d="M3 9 C 45 3, 95 2, 135 6 S 185 11, 197 4" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" vectorEffect="non-scaling-stroke" initial={{
                  pathLength: 0
                }} animate={{
                  pathLength: 1
                }} transition={{
                  duration: 0.3,
                  delay: 0.35,
                  ease: EASE
                }} data-id="element-170" data-mp="s3349bcaykwh" />
                </svg>
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.08,
            ease: EASE
          }} className="order-3 mx-auto mt-4 max-w-xl text-center text-[15px] lg:mx-0 lg:text-left leading-snug text-slate-900/75 sm:mt-8 sm:text-xl sm:leading-relaxed" data-id="element-171" data-mp="162ugb6j9dr7u">
              不用再由零開始備課。小一至中三六冊音樂電子教材：全年教學計劃、按分鐘編排的教案、三個程度工作紙、測驗及參考答案——另附五份附送教材。
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.16,
            ease: EASE
          }} className="order-4 mt-5 sm:mt-8 lg:mt-10" data-id="element-172" data-mp="1xavxukzeea7s">
              <div className="flex justify-center lg:justify-start" data-id="element-173" data-mp="2b2aggqpe89eb">
                <CtaButton href="#offer-card" className="w-full sm:w-auto" data-id="element-174" data-mp="2g0lpx0bs0hw0" />
              </div>
              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs text-slate-900/70 sm:mt-6 sm:gap-x-6 sm:text-sm lg:justify-start" data-id="element-175" data-mp="2ky44b68kbpbe">
                {heroGuarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-176" data-mp="2tzbsgvhd79rr">
                    <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-177" data-mp="2tx7nsbbn66qf" />
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease: EASE
        }} className="relative order-2 mx-auto mt-5 w-full max-w-xl sm:mt-12 lg:mt-0" data-id="element-178" data-mp="znn82dsd6ezz">
            <img src={PRODUCT_IMAGE} width={1200} height={1094} fetchPriority="high" alt="音樂備課寶™：小一至中三六冊音樂教材套裝，包括全年計劃、教案、工作紙、測驗和答案" className="relative mx-auto block h-auto w-full drop-shadow-xl" data-id="element-179" data-mp="9aqjo0l2hgr7" />
          </motion.figure>
        </div>
      </div>
    </section>;
}